// kiyoh-reviews.js
const PROXY_URL = 'https://kiyoh-reviews-zs.dylan-09c.workers.dev';

const loadKiyohReviews = async (productCode) => {
    const apiUrl = `${PROXY_URL}/?productCode=${productCode}`;

    try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        displayReviews(data);
        console.log(data);

    } catch (error) {
        console.error('Error loading reviews:', error);
        document.getElementById('reviews-container').innerHTML = '<p>Reviews kunnen niet geladen worden.</p>';
    }
};

const trimReviewText = (text, maxWords = 15) => {
    if (!text) return 'Geweldige ervaring!';

    const words = text.split(' ');
    if (words.length <= maxWords) {
        return text;
    }

    return words.slice(0, maxWords).join(' ') + '...';
};

// Sterrenrij in de stijl van het ontwerp: gevulde sterren vol, de rest gedimd.
const STER_SVG = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 0.44025L11.751 6.11625L18 6.9795L13.452 11.3505L14.562 17.5597L9 14.5845L3.43725 17.5597L4.548 11.3505L0 6.9795L6.249 6.11625L9 0.44025Z" fill="#25A757"/></svg>';

const sterrenHTML = (aantal) => {
    let html = '';
    for (let i = 1; i <= 5; i++) {
        html += `<span class="zs-ster${i <= aantal ? '' : ' zs-ster--leeg'}">${STER_SVG}</span>`;
    }
    return html;
};

const generateStars = (rating, maxRating = 10) => {
    const stars = Math.round((rating / maxRating) * 5);

    let starsHTML = '<div class="star-rating">';

    for (let i = 0; i < 5; i++) {
        const filled = i < stars;
        starsHTML += `
            <svg class="star ${filled ? 'star-filled' : 'star-empty'}" width="18" height="18" viewBox="0 0 24 24" fill="${filled ? '#FFD700' : 'none'}" stroke="#FFD700" stroke-width="1">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
        `;
    }

    starsHTML += '</div>';
    return starsHTML;
};

const displayReviews = (data) => {
    const container = document.getElementById('reviews-container');

    if (!data.reviews || data.reviews.length === 0) {
        container.innerHTML = '<p>Nog geen reviews voor dit product.</p>';
        return;
    }

    let reviewsHTML = `
        <div class="reviews-summary">
            <div class="average-rating">
                ${generateStars(data.averageRating)}
                <span class="rating-text">${data.averageRating}/10 (127 reviews)</span>
            </div>
        </div>
    `;

    container.innerHTML = reviewsHTML;
};

// Nieuwe functie voor shop reviews in je sectie
const loadShopReviewsForSlider = async () => {
    const apiUrl = `${PROXY_URL}/`;

    try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        console.log('Shop reviews:', data);

        if (data.reviews && data.reviews.length > 0) {
            replaceSliderWithKiyohReviews(data.reviews);
            return true; // Success
        }
        return false; // No reviews

    } catch (error) {
        console.error('Error loading shop reviews:', error);
        return false; // Error
    }
};

const replaceSliderWithKiyohReviews = (reviews) => {
    const track1 = document.getElementById('track-1');
    const track2 = document.getElementById('track-2');

    if (!track1) return;

    // === ✅ Shuffle de reviews om herhaling te voorkomen ===
    const shuffledReviews = [...reviews].sort(() => Math.random() - 0.5);

    let slidesHTML = '';

    shuffledReviews.forEach(review => {
        const displayRating = Math.round((review.rating / 10) * 5);

        const reviewText = trimReviewText(
            review.description || review.oneliner || review.reviewContent?.[2]?.rating,
            40
        );

        slidesHTML += `
            <div class="slide">
                <div class="slide-right">
                    <p class="name">${review.reviewAuthor || 'Anoniem'}</p>
                    <div class="zs-review-kaart__score">
                        <span class="zs-reviews__sterren" role="img" aria-label="${displayRating} van 5 sterren">${sterrenHTML(displayRating)}</span>
                        <span class="zs-reviews__cijfer">${displayRating}/5</span>
                    </div>
                    <p class="review-text">${reviewText}</p>
                </div>
            </div>
        `;
    });

    // Vul beide tracks met dezelfde (gehusselde) reviews
    track1.innerHTML = slidesHTML;
    if (track2) {
        track2.innerHTML = slidesHTML;
    }
};


// Functie om mobile carousel opnieuw te initialiseren
const reinitializeMobileCarousel = () => {
    const carousel = document.querySelector('#marquee-1');
    const track = document.querySelector('#track-1');
    const slides = Array.from(track.children);
    const indicatorsContainer = document.querySelector('#indicators-1');

    if (!indicatorsContainer || slides.length === 0) return;

    // Clear bestaande indicators
    indicatorsContainer.innerHTML = '';

    let currentIndex = 0;

    // Maak nieuwe indicators
    slides.forEach((_, index) => {
        const dot = document.createElement('span');
        dot.classList.add('carousel-dot');
        dot.innerHTML = '<span class="visually-hidden">Indicator ' + (index + 1) + '</span>';
        if (index === 0) dot.classList.add('active');
        dot.addEventListener('click', () => goToSlide(index));
        indicatorsContainer.appendChild(dot);
    });

    function updateIndicators() {
        const dots = indicatorsContainer.querySelectorAll('.carousel-dot');
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === currentIndex);
        });
    }

    function goToSlide(index) {
        currentIndex = index;
        const translateX = -currentIndex * 100;
        track.style.transform = `translateX(${translateX}%)`;
        updateIndicators();
    }

    // Reset naar eerste slide
    goToSlide(0);
};

// Functie om desktop marquee opnieuw te initialiseren
const reinitializeDesktopMarquee = () => {
    // Stop bestaande animaties door alle transforms te resetten
    const tracks = document.querySelectorAll('.marquee-track');
    tracks.forEach(track => {
        track.style.transform = 'translateX(0)';
        track.style.width = 'auto';
    });

    // Wacht even en start dan de bestaande setupDesktopMarquee logica opnieuw
    setTimeout(() => {
        if (window.setupDesktopMarquee) {
            window.setupDesktopMarquee();
        }
    }, 100);
};